import { tupleToStringKey } from 'js/lib/stringKeyTuple';

import { RouteNames } from 'pages/teach-course/constants';

import type { SocialProfile } from 'bundles/assess-common/types/SocialProfile';
import type GroupMember from 'bundles/author-groups/models/GroupMember';

// routes where the right sidebar is *not* rendered
export const rightSidebarBlacklistRoutes: string[] = [...Object.values(RouteNames.USER_CHANGE_LOG)];

/**
 * whether the right sidebar should be rendered for item grading
 *
 * @param  {Object} routes react-router routes object
 * @return {boolean}
 */
export const shouldShowRightSidebar = (currentRoute: { name: string }): boolean => {
  if (!currentRoute) {
    return false;
  }

  return !rightSidebarBlacklistRoutes.includes(currentRoute.name);
};

export const getUserItemInteractionId = (userId: string | number, courseBranchId: string, itemId: string): string => {
  return tupleToStringKey([userId, courseBranchId, itemId]);
};

export const getUserProfilesWithGroupMembershipUpdates = (
  groupMembers: Array<GroupMember>,
  socialProfiles: { [userId: string]: SocialProfile },
  isAnonymized = false
): { [userId: string]: SocialProfile } => {
  // returns a new map of socialProfiles with names replaced with groupMembership name if available, or with anonymized name if specified.
  const updatedSocialProfiles = socialProfiles;
  Object.keys(socialProfiles).forEach((learnerId) => {
    const groupMember = groupMembers.find((member) => member.userId.toString() === learnerId);
    if (groupMember) {
      // @ts-expect-error TS2532 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
      updatedSocialProfiles[learnerId].fullName = groupMember.getDisplayName(isAnonymized);
      if (isAnonymized) {
        // @ts-expect-error TS2532 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
        updatedSocialProfiles[learnerId].photoUrl = '';
      }
    }
  });
  return updatedSocialProfiles;
};
